import "./TimerItem.scss";

interface Props {
  number: number;
  numberType: string;
}

export const TimerItem = (props: Props) => {
  return (
    <div className="timerItem">
      {props.number.toString().padStart(2, "0")}
      {props.numberType}
    </div>
  );
};
